import { ACCOUNT_DELETION_API, ACCOUNT_DELETION_EMAIL } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(`${ACCOUNT_DELETION_API}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: ACCOUNT_DELETION_EMAIL, custom_fields: requestBody }),
    });

    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
